/**
 * 地图 接口的统一出口
 */
import axios from "../http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块，把请求字段直接映射过来

//  const api = '/home/'
const api = "/c-api/";

const index = {
  // 项目分类
  itemType(params) {
    return axios.post("/home/itemUtil/typeList", qs.stringify(params));
  },
  // 非遗地图周边
  zhoubian(params) {
    return axios.post("/home/map/item", qs.stringify(params));
  },
  // 项目详情
  itemDetail(params) {
    return axios.post("/home/map/shopDetail", qs.stringify(params));
  },
  // 中国地图
  areaItem(params) {
    return axios.post("/home/map/areaItem", qs.stringify(params));
  },
  // 项目列表
  areaItemList(params) {
    return axios.post("/home/map/areaItemList", qs.stringify(params));
  },
  // 关注匠人
  attention(params) {
    return axios.post("/home/itemAbout/attention", qs.stringify(params));
  },
  // 项目点报错
  baocuo(params) {
    return axios.post("/home/locationError/create", qs.stringify(params));
  },
  // 中国地图省项目坐标汇总
  allCoordinates(params) {
    return axios.post("/home/map/allCoordinates", qs.stringify(params));
  },
  // 项目评论
  createComment(params) {
    return axios.post("/home/itemAbout/createComment", qs.stringify(params));
  },
  // 项目级别
  levelList(params) {
    return axios.post("/home/itemUtil/levelList", qs.stringify(params));
  },
  // 项目类型
  cateList(params) {
    return axios.post("/home/itemUtil/cateList", qs.stringify(params));
  },
  // 项目模糊查询
  searchItem(params) {
    return axios.post(
      "/home/itemUtil/searchItemByConditions",
      qs.stringify(params)
    );
  },
  areaList(params) {
    return axios.get("/home/area/list", { params: params });
  },
  // 获取定位点红包
  getLocationNotes(params) {
    return axios.get('/home/map/getLocationNotes', { params: params });
  },
  // 领取红包
  lingNote(params) {
    return axios.post('/home/map/lingNote', qs.stringify(params));
  }
};

// 导出接口
export default index;
